import { connect } from 'react-redux';
import { getFunnelConversionInterval } from '../../../reducers/analyticsApp';
import { setConversionInterval } from '../../../actions/funnel';
import ConversionMenu from '../../../components/funnel/execution/ConversionMenu';

const mapStateToProps = (state) => ({ value: getFunnelConversionInterval(state) });

const mapDispatchToProps = (dispatch) => ({
  onChange: (interval) => dispatch(setConversionInterval(interval)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConversionMenu);
